import WalkthroughArrow from './WalkthroughArrow';

export default WalkthroughArrow;
